/**
 * ScienceSection Component
 * Statistics and science-backed claims
 */
export function ScienceSection() {
  const assetsUrl = `${window.template_root}/src/public/`;
  const stats = [
    {
      icon: `${assetsUrl}img/chart-pie-1.svg`,
      number: "95%",
      description: "Repopulation of gut microbiome",
    },
    {
      icon: `${assetsUrl}img/chart-pie-2.svg`,
      number: "60%",
      description: "Reduction in digestive distress",
    },
    {
      icon: `${assetsUrl}img/chart-pie-3.svg`,
      number: "82%",
      description: "Reduction in bloating after meals",
    },
    {
      icon: `${assetsUrl}img/chart-pie-4.svg`,
      number: "74%",
      description: "Optimized nutrient intake",
    },
  ];

  const scienceCardBg = `${assetsUrl}img/science-card-bg.webp`;

  return (
    <section
      id="science"
      className="py-16 px-8 max-md:py-8 max-md:px-4 max-md:pb-10"
    >
      {/* Header */}
      <div className="text-center mb-8 max-md:mb-6">
        <h2 className="font-family-title text-[2.5rem] font-normal mb-2 max-md:text-[1.8rem] max-md:leading-[1.3]">
          The Science Supporting Naori
        </h2>
        <p className="text-base leading-relaxed text-gray max-md:text-[0.95rem] max-md:leading-relaxed">
          Based on published{" "}
          <span className="highlight-underline">clinical studies</span> on
          individual ingredients
        </p>
      </div>

      {/* Stats Grid */}
      <div
        className="grid grid-cols-4 gap-6 max-w-[1100px] mx-auto
                      max-md:grid-cols-2 max-md:gap-4"
      >
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-white rounded-[1.5rem] p-6 max-md:p-5 max-md:rounded-[1.2rem]"
          >
            <img
              src={stat.icon}
              alt=""
              className="w-6 h-6 mb-2 max-md:w-5 max-md:h-5 max-md:mb-2"
            />
            <div className="font-family-title text-[3rem] font-normal mb-2 max-md:text-[2.5rem] max-md:leading-[1] max-md:mb-2">
              {stat.number}
            </div>
            <p className="text-sm leading-relaxed text-gray max-md:text-[0.74rem] max-md:leading-relaxed">
              {stat.description}
            </p>
          </div>
        ))}

        {/* Quality Card - Full Width */}
        <div
          className="col-span-4 bg-white rounded-[1.5rem] p-8 relative overflow-hidden
                        bg-(image:--scienceCardBg) bg-cover bg-right bg-no-repeat
                        max-md:p-6 max-md:rounded-[1.2rem] max-md:bg-none max-md:col-span-full"
          style={{ "--scienceCardBg": `url('${scienceCardBg}')` }}
        >
          <img
            src={`${assetsUrl}img/quality-badge.svg`}
            alt=""
            className="w-[38px] h-[38px] mb-2 max-md:w-[30px] max-md:h-[30px] max-md:mb-0"
          />
          <h3 className="font-family-title text-[2rem] font-normal mb-2 max-md:text-[1.6rem] max-md:leading-[1.3] max-md:mb-2">
            Quality You Can Trust
          </h3>
          <p className="max-w-[350px] leading-relaxed text-gray max-md:max-w-none max-md:text-sm max-md:leading-relaxed">
            We prioritize your health with the highest standards of quality and
            care.
          </p>
        </div>
      </div>
    </section>
  );
}

export default ScienceSection;
